import { __read, __spread } from "tslib";
import { get, every, round } from 'lodash-es';
import { NORMAL } from '../../constants/blendMode';
export function getOpacity(element) {
    var opacity = 1;
    var parent = element;
    while (parent) {
        opacity *= parent.itemProps.opacity;
        parent = parent.positionParent;
    }
    if (opacity < 1) {
        return round(opacity, 2);
    }
    return undefined;
}
export function getBlendMode(element) {
    var blendMode;
    var parent = element;
    while (parent) {
        (blendMode = parent.itemProps.blendMode);
        if (blendMode !== NORMAL) {
            return blendMode;
        }
        parent = parent.positionParent;
    }
    return blendMode;
}
export function hasNoShadow(element) {
    var shadowValues = __spread(get(element, 'shadowStyle.shadowOffset', [0, 0]), [
        get(element, 'shadowStyle.shadowBlur', 0),
    ]);
    var hasNoShadowVals = every(shadowValues, function (v) { return v === 0; });
    return hasNoShadowVals;
}
